export default __webpack_public_path__ + "static/favicon-fc6a7cd3923168e66b861d046aedf36b.ico";